<template>
  <div>
    <v-progress-circular :color="color" indeterminate :width="2" :size="20"></v-progress-circular>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary',
    },
  },
};
</script>
